<template>
  <div class="reward-detail-page">
    <top-bar :title="$t('rewardDetail.title')" @back="back"></top-bar>

    <div class="content-container">
      <!-- Logo and Title Section -->
      <div class="header-section">
        <div class="logo-container">
          <img :src="rocketUrl" alt="CoinOcean" class="rocket-logo">
        </div>
        <div class="title-text">CoinOcean</div>
      </div>

      <!-- Description Section -->
      <div class="description-section">
        <div class="description-text">
          {{$t('rewardDetail.description')}}
        </div>
      </div>

      <!-- Reward Table Section -->
      <div class="table-section">
        <div class="table-container">
          <div class="table-header">
            <div class="header-cell balance">{{$t('rewardDetail.balance')}}</div>
            <div class="header-cell reward">{{$t('rewardDetail.reward')}}</div>
          </div>
          <div class="table-body">
            <div class="table-row" v-for="(item, index) in rewardData" :key="index">
              <div class="table-cell balance">{{item.balance}}</div>
              <div class="table-cell reward">{{item.reward}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Note Section -->
      <div class="note-section">
        <div class="note-text">
          {{$t('rewardDetail.note')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topBar from '@/components/topBar'

export default {
  name: 'RewardDetail',
  components: {
    topBar
  },
  data() {
    return {
      rocketUrl: require('../../assets/imgs/coinspot-v-sml.png'),
      rewardData: [
        { balance: '5000', reward: '388' },
        { balance: '10000', reward: '888' },
        { balance: '20000', reward: '1888' },
        { balance: '50000', reward: '3888' },
        { balance: '100000', reward: '8888' },
        { balance: '200000', reward: '18888' },
        { balance: '500000', reward: '38888' }
      ]
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.reward-detail-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #ffffff;
  padding-top: 44px; /* 为topBar留出空间 */

  .content-container {
    padding: 20px 15px;
    padding-bottom: 40px;
  }

  .header-section {
    text-align: center;
    margin-bottom: 25px;

    .logo-container {
      margin-bottom: 12px;

      .rocket-logo {
        width: 50px;
        height: 50px;
        object-fit: contain;
        filter: drop-shadow(0 0 12px rgba(255, 215, 0, 0.5));
      }
    }

    .title-text {
      font-size: 24px;
      font-weight: bold;
      color: #FFD700;
      text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.8);
      letter-spacing: 1.5px;
    }
  }

  .description-section {
    margin-bottom: 25px;

    .description-text {
      font-size: 13px;
      line-height: 1.5;
      text-align: center;
      color: #ffffff;
      background: rgba(139, 69, 19, 0.8);
      padding: 16px;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    }
  }

  .table-section {
    margin-bottom: 25px;

    .table-container {
      border: 2px solid #FFD700;
      border-radius: 10px;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.4);
      box-shadow: 0 4px 20px rgba(255, 215, 0, 0.2);

      .table-header {
        background: linear-gradient(90deg, #FFD700 0%, #FFA500 100%);
        color: #000000;
        font-weight: bold;
        font-size: 15px;
        display: flex;

        .header-cell {
          flex: 1;
          padding: 12px 8px;
          text-align: center;
          border-right: 1px solid #000000;

          &:last-child {
            border-right: none;
          }
        }
      }

      .table-body {
        .table-row {
          display: flex;
          border-bottom: 1px solid #FFD700;

          &:last-child {
            border-bottom: none;
          }

          .table-cell {
            flex: 1;
            padding: 10px 8px;
            text-align: center;
            font-size: 13px;
            font-weight: 500;
            border-right: 1px solid #FFD700;

            &:last-child {
              border-right: none;
            }

            &.balance {
              color: #ffffff;
            }

            &.reward {
              color: #FFD700;
              font-weight: bold;
            }
          }
        }
      }
    }
  }

  .note-section {
    .note-text {
      font-size: 11px;
      line-height: 1.5;
      color: #cccccc;
      text-align: left;
      padding: 12px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 6px;
      border-left: 3px solid #FFD700;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
